module.exports = __webpack_public_path__ + "img/2_1.d4bd7768.png";